// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchFilterPlans-searchFilterInput-ikqvI {
    max-width: 265px;
}

.SearchFilterPlans-searchFilterSelect-wZ80f {
    max-width: 161px;
}`, "",{"version":3,"sources":["webpack://./src/components/ServicePlanContainer/SearchFilterPlans.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".searchFilterInput {\n    max-width: 265px;\n}\n\n.searchFilterSelect {\n    max-width: 161px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchFilterInput": `SearchFilterPlans-searchFilterInput-ikqvI`,
	"searchFilterSelect": `SearchFilterPlans-searchFilterSelect-wZ80f`
};
module.exports = ___CSS_LOADER_EXPORT___;
